import { render, staticRenderFns } from "./industrySalary.vue?vue&type=template&id=53483ad2&scoped=true&"
import script from "./industrySalary.vue?vue&type=script&lang=js&"
export * from "./industrySalary.vue?vue&type=script&lang=js&"
import style0 from "../constant/css/drawer.css?vue&type=style&index=0&id=53483ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53483ad2",
  null
  
)

export default component.exports